import { render, staticRenderFns } from "./SurveyResultCard.vue?vue&type=template&id=f714c428"
import script from "./SurveyResultCard.vue?vue&type=script&lang=js"
export * from "./SurveyResultCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports